var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "white",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7234 21.5C14.5415 22.7721 13.4474 23.75 12.125 23.75C10.8026 23.75 9.70854 22.7721 9.52658 21.5H8.75V12.5C8.75 12.0858 9.08579 11.75 9.5 11.75H20C20.4142 11.75 20.75 12.0858 20.75 12.5V14H23L25.25 17.0418V21.5H23.7234C23.5414 22.7721 22.4474 23.75 21.125 23.75C19.8026 23.75 18.7086 22.7721 18.5266 21.5H14.7234ZM19.25 13.25H10.25V19.2879C10.7264 18.8017 11.3905 18.5 12.125 18.5C13.1722 18.5 14.0761 19.1131 14.4974 20H18.7526C18.8784 19.7352 19.0472 19.4948 19.25 19.2879V13.25ZM20.75 17.75H23.75V17.5363L22.2438 15.5H20.75V17.75ZM21.125 22.25C21.6148 22.25 22.0315 21.9369 22.186 21.5C22.2274 21.3827 22.25 21.2565 22.25 21.125C22.25 20.5037 21.7463 20 21.125 20C20.5037 20 20 20.5037 20 21.125C20 21.2565 20.0226 21.3827 20.064 21.5C20.2185 21.9369 20.6352 22.25 21.125 22.25ZM13.25 21.125C13.25 20.5037 12.7463 20 12.125 20C11.5037 20 11 20.5037 11 21.125C11 21.2565 11.0226 21.3827 11.064 21.5C11.2185 21.9369 11.6352 22.25 12.125 22.25C12.6148 22.25 13.0315 21.9369 13.186 21.5C13.2274 21.3827 13.25 21.2565 13.25 21.125Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupang);
export default __webpack_public_path__ + "static/media/coupang.990041e0fdb79a1f8a662c064416cbd4.svg";
export { ForwardRef as ReactComponent };